import * as React from "react";
import {cs} from "../../../../../../../../../../react/chain-services";
import "./viewing-panel.scss";
import {chain} from "../../../../../../../../../../utils/fs";

export const ViewingPanel = ({data, onEdit}) => cs(
    () => (
        <div className="viewing-panel-8a5">
            <div className="title">
                <div className="label">
                    Addressing Options
                </div>
                <a className="edit-action" onClick={onEdit}>
                    Edit
                </a>
            </div>
            <div className="sub-title">
                {chain(
                    data?.type,
                    (type) => type === "owner" ? (
                        "Use resident name"
                    ) : type === "custom" ? (
                        "Custom name: \"" + data.value + "\""
                    ) : (
                        `Add "${type.split("_").join(" ").toUpperCase()}" below recipient name`
                    ),
                )}
            </div>
        </div>
    ),
);

